import styles from './SidebarTip.module.css'
import { byDesign } from '@/infra/design'
import imgManageBillingUrl from '@/assets/misc/img_manage-billing.svg'
import MakeDepositIllustration from '@/components/SpotIllustration/MakeDepositIllustration'

export function SidebarTip() {
  return (
    <div className={styles.root}>
      <div className={styles.box}>
        <div className={styles.content}>
          {byDesign(
            <img
              className={styles.illustration}
              src={imgManageBillingUrl}
              alt="Two hands exchanging a coin"
            />,
            <MakeDepositIllustration
              className={styles.illustration}
              label="Two hands exchanging a coin"
            />,
          )}
          <h1 className={styles.title}>Track your earnings</h1>
          <p className={styles.description}>
            We’re making improvements to provide insights into your earnings on
            the platform.
          </p>
        </div>
      </div>
    </div>
  )
}
